module.exports = __webpack_public_path__ + "static/Kai-Mykkanen-83bcb21d9fe3fcae9913def2f614519a.jpeg";